<template>
  <div class="border-t px-6 py-4" style="border-color: var(--border-default); background-color: var(--bg-surface-sunken);">
    <div class="flex items-center justify-between">
      <!-- Back button -->
      <button
        v-if="!isFirstStep"
        type="button"
        class="btn btn-secondary"
        :disabled="saving"
        @click="$emit('prev')">
        <svg class="mr-2 h-4 w-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
        Back
      </button>
      <div v-else />

      <!-- Next/Complete button -->
      <button
        v-if="!isLastStep"
        type="button"
        class="btn btn-primary"
        :disabled="!canProceed || saving"
        @click="$emit('next')">
        <template v-if="saving">
          <svg class="mr-2 h-4 w-4 flex-shrink-0 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          Saving...
        </template>
        <template v-else>
          Continue
          <svg class="ml-2 h-4 w-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </template>
      </button>

      <button
        v-else
        type="button"
        class="btn btn-primary"
        :disabled="saving"
        @click="$emit('complete')">
        <template v-if="saving">
          <svg class="mr-2 h-4 w-4 flex-shrink-0 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          Finishing...
        </template>
        <template v-else>
          Complete Setup
          <svg class="ml-2 h-4 w-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </template>
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  isFirstStep: { type: Boolean, required: true },
  isLastStep: { type: Boolean, required: true },
  canProceed: { type: Boolean, required: true },
  saving: { type: Boolean, required: true }
})

defineEmits(['prev', 'next', 'complete'])
</script>
